import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const admin = async (id?: number) => axios.get(Routes.ADMIN + "/" + id);

export const useAdmin = (id?: number) =>
  useQuery({
    queryKey: [Keys.ADMIN_QRY, id],
    queryFn: () => admin(id),
    enabled: id ? true : false,
  });
